import { useEffect, useState } from 'react';
import { Icon } from './Icon.tsx';
import { t } from '@/lib/strings';

type Theme = 'light' | 'dark';
const STORAGE_KEY = 'wappro.theme';

function getInitial(): Theme {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function apply(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

export function ThemeToggle(): JSX.Element {
  const [theme, setTheme] = useState<Theme>(() => getInitial());

  useEffect(() => {
    apply(theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <button
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      aria-label={theme === 'dark' ? t.theme.switchToLight : t.theme.switchToDark}
      className="grid size-11 place-items-center rounded-full text-muted-foreground hover:bg-muted/70"
    >
      <Icon name={theme === 'dark' ? 'light_mode' : 'dark_mode'} size={20} />
    </button>
  );
}
